import { createFrontEndContext } from 'board-vitals-shared';
import { Bugfender } from '@bugfender/sdk';
import Config from 'config';

const {
  Hooks, Reducers, Actions, Selectors, Constants, Helpers
} = createFrontEndContext({ Bugfender, Config });


export {
  Hooks, Reducers, Actions, Selectors, Constants, Helpers
};
